import Alert from '@material-ui/icons/ErrorOutline'
import { Button, ComponentVersionsInherit, ComponentVersions_3_0, styled, Typography } from 'opensolar-ui'
import { useTranslate } from 'ra-core'
import React from 'react'
import { useChatContext } from './ChatContext'

const BannerContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
  padding: '10px 16px',
  borderTop: '1px solid rgba(0, 0, 0, 0.08)',
  background: 'rgb(249, 250, 251)',
  transition: 'opacity 0.2s ease',
})

const ContentWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flex: 1,
})

const WarningIcon = styled(Alert)({
  color: '#6b7280',
  fontSize: '22px',
  flexShrink: 0,
})

const MessageText = styled(Typography)({
  color: '#4b5563',
})

const RetryButton = styled(Button)({
  flexShrink: 0,
  textTransform: 'none',
  fontWeight: 500,
})

const NetworkReconnectBanner: React.FC = () => {
  const { onRetry } = useChatContext()
  const translate = useTranslate()
  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <BannerContainer>
        <ContentWrapper>
          <WarningIcon />
          <MessageText textVariant="caption1">
            {translate('Network reconnected')}
            <br />
            {translate('Your last message failed to send.')}
          </MessageText>
        </ContentWrapper>
        <RetryButton size="small" variant="outlined" color="info" onClick={onRetry}>
          {translate('Retry')}
        </RetryButton>
      </BannerContainer>
    </ComponentVersionsInherit>
  )
}

export default NetworkReconnectBanner
